import { render, staticRenderFns } from "./BSA.vue?vue&type=template&id=73453e8e&scoped=true&lang=pug&"
import script from "./BSA.vue?vue&type=script&lang=js&"
export * from "./BSA.vue?vue&type=script&lang=js&"
import style0 from "./BSA.vue?vue&type=style&index=0&id=73453e8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73453e8e",
  null
  
)

export default component.exports